import React, {useState} from 'react';
import {
    Button,
    CardText,
    Col,
    Modal,
    ModalBody,
    ModalHeader,
    Row,
    Spinner
} from "reactstrap";
import toast from "react-hot-toast";
import axios from "axios";

const DeleteUser = ({isOpen, handleClose, item}) => {

    const [loading, setLoading] = useState(false);

    const handleDelete = async () => {
        setLoading(true);
        const res = await axios.delete(`${process.env.REACT_APP_API_URL}/users/${item.noUser}`);
        if (res.data.header.code) {
            handleClose(false);
            toast.error(`La usuario - ${item.email} ha sido eliminada`);
            setTimeout(() => window.location.reload(), 500);
        } else {
            setLoading(false);
            toast.error(res.data.header.message);
        }
    }

    return (
        <Modal isOpen={isOpen} toggle={() => handleClose(false)} className='modal-dialog-centered modal-lg'>
            <ModalHeader className='bg-transparent' toggle={() => handleClose(false)}></ModalHeader>
            <ModalBody className='px-sm-5 mx-50 pb-5'>
                <div className='text-center mb-2'>
                    <h1 className='mb-1'>Eliminar usuario</h1>
                </div>
                {loading ? <Row>
                    <div className='col-12 px-2 py-4 text-center'>
                        <Spinner size='lg'/>
                        <CardText className={'py-1 fs-5'}>Eliminando usuario...</CardText>
                    </div>
                </Row> : <Row className='gy-1 pt-75'>
                    <Col md={12} xs={12} className={'text-center'}>
                        <p>Esta seguro de eliminar <strong>"{item?.userName}"</strong> con los datos asociados?</p>
                    </Col>
                    <Col xs={12} className='text-center mt-2 pt-50'>
                        <Button type='button'
                                onClick={handleDelete}
                                className='me-1' color='danger' disabled={!item}>
                            Eliminar
                        </Button>
                        <Button type='reset' color='secondary' outline onClick={() => handleClose(false)}>
                            Cancelar
                        </Button>
                    </Col>
                </Row>}

            </ModalBody>
        </Modal>
    );
};

export default DeleteUser;
